import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21a91876")

_pushScopeId("data-v-21a91876")
const _hoisted_1 = { class: "py-6 flex flex-row justify-between items-center border-b border-gray-lp-900" }
const _hoisted_2 = { class: "flex flex-row text-12px xxl:text-14px items-center" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_4 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_5 = { class: "flex flex-col mt-6 mb-2 transition duration-1000 ease-linear" }
const _hoisted_6 = { class: "flex flex-row justify-between" }
const _hoisted_7 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-2" }
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-wrap md:flex-row w-full"
}
const _hoisted_10 = { class: "flex flex-col container-origin-destination w-full md:w-auto" }
const _hoisted_11 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-2" }
const _hoisted_12 = { class: "flex flex-col md:flex-row" }
const _hoisted_13 = { class: "text-black-lp-300 font-semibold text-12px mt-2 mb-2 block md:hidden" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-row mt-2 md:mt-0"
}
const _hoisted_15 = { class: "flex flex-col mr-6 mt-1 md:mt-0" }
const _hoisted_16 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-1" }
const _hoisted_17 = { class: "flex flex-row items-center gap-2" }
const _hoisted_18 = {
  key: 0,
  "data-testid": "tariff-rates-check-error-max-weight",
  class: "text-red-lp-100 text-12px"
}
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_20 = {
  key: 1,
  class: "w-full mt-6 block md:hidden"
}
const _hoisted_21 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-2" }
const _hoisted_22 = {
  key: 3,
  class: "w-1/4 flex flex-col"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-2" }, " Client/Partner ", -1)
const _hoisted_24 = {
  key: 4,
  class: "w-2/12 mt-6 hidden md:flex"
}
const _hoisted_25 = {
  key: 0,
  class: "flex flex-row pt-6 gap-6 items-end"
}
const _hoisted_26 = { class: "w-4/12 flex flex-col" }
const _hoisted_27 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-2" }
const _hoisted_28 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_29 = { class: "flex flex-row ml-1" }
const _hoisted_30 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_31 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_32 = { class: "flex flex-row ml-1" }
const _hoisted_33 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_34 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_35 = { class: "w-2/12 flex flex-col" }
const _hoisted_36 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-2" }
const _hoisted_37 = { class: "flex flex-row items-center gap-2" }
const _hoisted_38 = {
  key: 0,
  "data-testid": "tariff-rates-check-error-max-weight",
  class: "text-red-lp-100 text-12px mt-2"
}
const _hoisted_39 = { class: "w-2/12" }
const _hoisted_40 = { class: "flex justify-end mb-4" }
const _hoisted_41 = { class: "flex justify-end border-t border-gray-lp-400" }
const _hoisted_42 = {
  key: 0,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 ml-2"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9646 9.07133L8.5946 5.75533C8.26527 5.43133 7.7326 5.43133 7.40326 5.75533L4.0346 9.07133C3.70526 9.39466 3.70526 9.91933 4.0346 10.2433C4.3626 10.5673 4.8966 10.5673 5.2246 10.2433L7.99993 7.514L10.7733 10.2433C11.1026 10.5673 11.6353 10.5673 11.9646 10.2433C12.1286 10.082 12.2106 9.86933 12.2106 9.65733C12.2106 9.44533 12.1286 9.23266 11.9646 9.07133Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_44 = {
  key: 1,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 ml-2"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9639 5.75466C11.6359 5.43066 11.1019 5.43066 10.7739 5.75466L7.99924 8.48399L5.22591 5.75466C4.89657 5.43066 4.36391 5.43066 4.03457 5.75466C3.87057 5.91666 3.78857 6.12866 3.78857 6.34066C3.78857 6.55266 3.87057 6.76532 4.03457 6.92666L7.40457 10.2427C7.73391 10.5667 8.26657 10.5667 8.59591 10.2427L11.9646 6.92666C12.2932 6.60332 12.2932 6.07866 11.9639 5.75466Z",
  fill: "currentColor"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_InputAdornment = _resolveComponent("InputAdornment")!
  const _component_PillSwitch = _resolveComponent("PillSwitch")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ButtonFill = _resolveComponent("ButtonFill")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_InputDimension = _resolveComponent("InputDimension")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(typeof _ctx.currentRoutes === 'string' && _ctx.currentRoutes.toLowerCase().includes("tarif")
              ? _ctx.$t("shipmentRates.titleRouteName")
              : _ctx.currentRoutes), 1)
      ]),
      (!_ctx.isSenderAccount && _ctx.isPosAccount)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.onButtonRight,
              outline: "",
              title: _ctx.labelButtonRight,
              textColor: "red-lp-100",
              iconV2: "",
              icon: "file-download",
              iconColor: "red-lp-100"
            }, null, 8, ["onClick", "title"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", _hoisted_5, [
        (_ctx.hasSlotData)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode("div", _hoisted_6, [
                (!_ctx.isSenderAccount)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: `${_ctx.isFilterAble ? 'w-1/2' : 'w-3/5'} flex flex-col mr-6`
                    }, [
                      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("shipmentRates.titleAddressOriginDestination")), 1),
                      _createVNode("div", _hoisted_8, [
                        _createVNode(_component_SelectSearch, {
                          placeholder: _ctx.placeholderOrigin,
                          value: _ctx.searchValueOrigin,
                          dataSearch: _ctx.selectSearchDataOrigin,
                          onSearch: _ctx.onSelectSearchOrigin,
                          onOpenSearch: _ctx.onOpenSelectSearchOrigin,
                          onCloseSearch: _ctx.onCloseSelectSearchOrigin,
                          onChooseSearch: _ctx.onChooseSelectSearchOrigin,
                          isOpenSearch: _ctx.statusSelectSearchOrigin,
                          notFound: _ctx.selectSearchOriginNotFound,
                          noSpaceLeft: false,
                          noSpaceRight: true,
                          class: "w-full"
                        }, null, 8, ["placeholder", "value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound"]),
                        _createVNode(_component_SelectSearch, {
                          placeholder: _ctx.placeholderDestination,
                          value: _ctx.searchValueDestination,
                          dataSearch: _ctx.selectSearchDataDestination,
                          onSearch: _ctx.onSelectSearchDestination,
                          onOpenSearch: _ctx.onOpenSelectSearchDestination,
                          onCloseSearch: _ctx.onCloseSelectSearchDestination,
                          onChooseSearch: _ctx.onChooseSelectSearchDestination,
                          isOpenSearch: _ctx.statusSelectSearchDestination,
                          notFound: _ctx.selectSearchDestinationNotFound,
                          noSpaceLeft: true,
                          noSpaceRight: true,
                          class: "w-full"
                        }, null, 8, ["placeholder", "value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound"])
                      ])
                    ], 2))
                  : (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.isScreenMD
                      ? _ctx.$t("shipmentRates.titleAddressOriginDestination")
                      : _ctx.$t("shipmentRates.titleAddressOrigin")), 1),
                        _createVNode("div", _hoisted_12, [
                          _createVNode(_component_SelectSearch, {
                            "data-testid": "tariff-rates-check-select-origin",
                            placeholder: _ctx.placeholderOrigin,
                            value: _ctx.searchValueOrigin,
                            dataSearch: _ctx.selectSearchDataOrigin,
                            onSearch: _ctx.onSelectSearchOrigin,
                            onOpenSearch: _ctx.onOpenSelectSearchOrigin,
                            onCloseSearch: _ctx.onCloseSelectSearchOrigin,
                            onChooseSearch: _ctx.onChooseSelectSearchOrigin,
                            isOpenSearch: _ctx.statusSelectSearchOrigin,
                            notFound: _ctx.selectSearchOriginNotFound,
                            noSpaceLeft: false,
                            noSpaceRight: _ctx.isScreenMD,
                            class: "w-full"
                          }, null, 8, ["placeholder", "value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound", "noSpaceRight"]),
                          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("shipmentRates.titleAddressDestination")), 1),
                          _createVNode(_component_SelectSearch, {
                            "data-testid": "tariff-rates-check-select-destination",
                            placeholder: _ctx.placeholderDestination,
                            value: _ctx.searchValueDestination,
                            dataSearch: _ctx.selectSearchDataDestination,
                            onSearch: _ctx.onSelectSearchDestination,
                            onOpenSearch: _ctx.onOpenSelectSearchDestination,
                            onCloseSearch: _ctx.onCloseSelectSearchDestination,
                            onChooseSearch: _ctx.onChooseSelectSearchDestination,
                            isOpenSearch: _ctx.statusSelectSearchDestination,
                            notFound: _ctx.selectSearchDestinationNotFound,
                            noSpaceLeft: _ctx.isScreenMD,
                            noSpaceRight: _ctx.isScreenMD,
                            class: "w-full"
                          }, null, 8, ["placeholder", "value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound", "noSpaceLeft", "noSpaceRight"])
                        ])
                      ]),
                      (_ctx.isSenderAccount)
                        ? (_openBlock(), _createBlock("div", _hoisted_14, [
                            _createVNode("div", _hoisted_15, [
                              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('Berat/Paket')), 1),
                              _createVNode("div", _hoisted_17, [
                                _createVNode(_component_InputAdornment, {
                                  dataTestid: "tariff-rates-check-input-weight",
                                  weight: _ctx.form.weight,
                                  "onUpdate:weight": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.weight = $event)),
                                  onChange: _ctx.onChangeWeight,
                                  isError: _ctx.isWeightError,
                                  adornment: _ctx.weightUnit === 'gr' ? 'Gr' : 'Kg'
                                }, null, 8, ["weight", "onChange", "isError", "adornment"]),
                                _createVNode(_component_PillSwitch, {
                                  dataTestid: "tariff-rates-check-switch-weight-unit",
                                  modelValue: _ctx.weightUnit,
                                  options: _ctx.weightUnitOptions,
                                  "onUpdate:modelValue": _ctx.setWeightUnit
                                }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                              ]),
                              (_ctx.isWeightError)
                                ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.weightErrorCaption), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.isSenderAccount)
                              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                                  _createVNode(_component_DataWrapper, {
                                    label: _ctx.$t('Harga Barang')
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_lp_input, {
                                        "data-testid": "tariff-rates-check-input-price",
                                        modelValue: _ctx.form.price,
                                        "onUpdate:modelValue": [
                                          _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.price = $event)),
                                          _ctx.onChangePrice
                                        ],
                                        prefix: _ctx.accountCurrency,
                                        format: _ctx.formatInputPrice,
                                        placeholder: "e.g 20.000"
                                      }, null, 8, ["modelValue", "prefix", "format", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isSenderAccount)
                        ? (_openBlock(), _createBlock("div", _hoisted_20, [
                            _createVNode(_component_ButtonFill, {
                              "data-testid": "tariff-rates-check-button-submit",
                              title: "Cek Tarif",
                              isLoading: _ctx.isLoading,
                              onClick: _ctx.onFilter,
                              class: "px-8 py-1",
                              isDisabled: _ctx.isDisabled
                            }, null, 8, ["isLoading", "onClick", "isDisabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ])),
                (!_ctx.isSenderAccount)
                  ? (_openBlock(), _createBlock("div", {
                      key: 2,
                      class: `${_ctx.isFilterAble ? 'w-1/4' : 'w-2/5'} flex flex-col mr-6`
                    }, [
                      _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("shipmentRates.titleShipmentType")), 1),
                      _createVNode(_component_Select, {
                        dataSelect: _ctx.productData,
                        onOpenSelect: _ctx.onOpenProductSelect,
                        onCloseSelect: _ctx.onCloseProductSelect,
                        onChooseSelect: _ctx.onSelectProduct,
                        value: _ctx.valueProduct,
                        isOpenMenu: _ctx.productSelect,
                        class: "w-full z-20"
                      }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.isFilterAble && !_ctx.isSenderAccount)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, [
                      _hoisted_23,
                      (_ctx.isFilterAble)
                        ? (_openBlock(), _createBlock(_component_SelectSearchV2, {
                            key: _ctx.form.client,
                            onFilter: _ctx.fetchClientPartner,
                            onFocus: _ctx.onGetListPartner,
                            isLoading: _ctx.isLoadingClientPartner,
                            options: _ctx.clientPartnerData,
                            keyName: "name",
                            keyValue: "code",
                            placeholder: _ctx.$t('Ketik atau pilih client/partner'),
                            modelValue: _ctx.form.client,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.client = $event)),
                            onChange: _ctx.onChangeClient,
                            isDisabled: _ctx.isShowListClient
                          }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onChange", "isDisabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isSenderAccount)
                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                      _createVNode(_component_ButtonFill, {
                        "data-testid": "tariff-rates-check-button-submit",
                        title: _ctx.$t('Cek Tarif'),
                        isLoading: _ctx.isLoading,
                        onClick: _ctx.onFilter,
                        class: "px-8 py-1",
                        isDisabled: _ctx.isDisabled
                      }, null, 8, ["title", "isLoading", "onClick", "isDisabled"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isSenderAccount)
                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("shipmentRates.titleCommodityType")), 1),
                      _createVNode(_component_SelectSearchV2, {
                        onFilter: _ctx.fetchCommodity,
                        onFocus: _ctx.onGetCommodityList,
                        isLoading: _ctx.loadingCommodity,
                        options: _ctx.commodityList,
                        keyName: "commodity_name",
                        keyValue: "commodity_id",
                        placeholder: _ctx.$t('shipmentRates.placeholderSelectCommodity'),
                        modelValue: _ctx.form.commodity,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.commodity = $event)),
                        maxHeight: "270px",
                        useInfiniteScroll: "",
                        onScrolled: _ctx.fetchCommodityListInfiniteScroll,
                        idInput: "commodity-booking",
                        autoUpDown: "",
                        onChange: _ctx.onChangeCommodity
                      }, {
                        "custom-option": _withId(({ item }) => [
                          _createVNode("div", _hoisted_28, [
                            _createVNode("div", null, _toDisplayString(item.commodity_name), 1),
                            _createVNode("div", _hoisted_29, [
                              (item.isQuarantine)
                                ? (_openBlock(), _createBlock("span", _hoisted_30, " K "))
                                : _createCommentVNode("", true),
                              (item.isDangerousGoods)
                                ? (_openBlock(), _createBlock("span", _hoisted_31, " DG "))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        "selected-info": _withId(({ selected }) => [
                          _createVNode("div", _hoisted_32, [
                            (selected && selected.isQuarantine)
                              ? (_openBlock(), _createBlock("span", _hoisted_33, " K "))
                              : _createCommentVNode("", true),
                            (selected && selected.isDangerousGoods)
                              ? (_openBlock(), _createBlock("span", _hoisted_34, " DG "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onScrolled", "onChange"])
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("shipmentRates.titleWeight")), 1),
                      _createVNode("div", _hoisted_37, [
                        _createVNode(_component_InputAdornment, {
                          dataTestid: "tariff-rates-check-input-weight",
                          weight: _ctx.form.weight,
                          "onUpdate:weight": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.weight = $event)),
                          onChange: _ctx.onChangeWeight,
                          isError: _ctx.isWeightError,
                          adornment: _ctx.weightUnit === 'gr' ? 'Gr' : 'Kg'
                        }, null, 8, ["weight", "onChange", "isError", "adornment"]),
                        _createVNode(_component_PillSwitch, {
                          dataTestid: "tariff-rates-check-switch-weight-unit",
                          modelValue: _ctx.weightUnit,
                          options: _ctx.weightUnitOptions,
                          "onUpdate:modelValue": _ctx.setWeightUnit
                        }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                      ]),
                      (_ctx.isWeightError)
                        ? (_openBlock(), _createBlock("div", _hoisted_38, _toDisplayString(_ctx.weightErrorCaption), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_DataWrapper, {
                      class: "w-3/12",
                      suffix: _ctx.$t('shipmentRates.titleDimensionSuffix'),
                      label: _ctx.$t('shipmentRates.titleDimensionPackage'),
                      asterisk: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_InputDimension, {
                          length: _ctx.form.length,
                          "onUpdate:length": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.length = $event)),
                          width: _ctx.form.width,
                          "onUpdate:width": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.width = $event)),
                          height: _ctx.form.height,
                          "onUpdate:height": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.height = $event)),
                          onChange: _ctx.onChangeDimension
                        }, null, 8, ["length", "width", "height", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["suffix", "label"]),
                    _createVNode(_component_DataWrapper, {
                      class: "w-3/12 -mb-1.5",
                      label: _ctx.$t('shipmentRates.titleItemPrice'),
                      asterisk: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          "data-testid": "tariff-rates-check-input-price",
                          modelValue: _ctx.form.price,
                          "onUpdate:modelValue": [
                            _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.price = $event)),
                            _ctx.onChangePrice
                          ],
                          prefix: 
                  _ctx.isInternalOutsideID && _ctx.searchValueOrigin
                    ? 'RM'
                    : _ctx.$t('shipmentRates.titlePrefixItemPrice')
                ,
                          format: _ctx.formatInputPrice,
                          placeholder: 
                  _ctx.isInternalOutsideID && _ctx.searchValueOrigin
                    ? 'e.g 6.00'
                    : _ctx.$t('shipmentRates.placeholderItemPrice')
                
                        }, null, 8, ["modelValue", "prefix", "format", "placeholder", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode("div", _hoisted_39, [
                      _createVNode(_component_ButtonFill, {
                        "data-testid": "tariff-rates-check-button-submit",
                        title: _ctx.$t('shipmentRates.titleButtonCheckRates'),
                        isLoading: _ctx.isLoading,
                        onClick: _ctx.onFilter,
                        class: "px-8 py-1",
                        isDisabled: _ctx.isDisabled
                      }, null, 8, ["title", "isLoading", "onClick", "isDisabled"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _createVNode("div", _hoisted_40, [
        (_ctx.isReset)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              onClick: _ctx.onReset,
              flat: "",
              dense: "",
              title: "Reset Filter",
              textColor: "red-lp-100",
              fontWeight: "semibold"
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _ctx.isFilterShow]
    ]),
    _createVNode("div", _hoisted_41, [
      _createVNode("button", {
        class: "focus:outline-none flex flex-row items-center text-black-lp-200 text-12px px-4 py-2 mr-6 border-l border-b border-r border-gray-lp-400 rounded-b shadow",
        onClick: _cache[10] || (_cache[10] = () => _ctx.setFilterShow(!_ctx.isFilterShow))
      }, [
        _createVNode("div", null, _toDisplayString(_ctx.isFilterShow
              ? _ctx.$t("shipmentRates.titleToggleFilterOpen")
              : _ctx.$t("shipmentRates.titleToggleFilterClose")) + " Filter ", 1),
        (_ctx.isFilterShow)
          ? (_openBlock(), _createBlock("svg", _hoisted_42, [
              _hoisted_43
            ]))
          : (_openBlock(), _createBlock("svg", _hoisted_44, [
              _hoisted_45
            ]))
      ])
    ])
  ]))
})